module.exports = __webpack_public_path__ + "img/empty_icon.935d1b42.png";